(function () {

  function updateRow(wrapper) {
    console.log('hi get')
    const qtyInput = wrapper.querySelector('.cartorderQty');
    const meterInput = wrapper.querySelector('.cartmeterQty');
    const hiddenInput = wrapper.querySelector('.meterHidden');
    const line = wrapper.dataset.lineIndex;

    if (!qtyInput || !meterInput || !line) return;

    console.log('hi get')

    const step = parseInt(meterInput.step, 10);

    let qty = parseInt(qtyInput.value, 10);
    let meter = parseInt(meterInput.value, 10);

    if (isNaN(qty) || qty < 1) qty = 1;
    if (isNaN(meter) || meter < step) meter = step;
    meter = Math.round(meter / step) * step;

    qtyInput.value = qty;
    meterInput.value = meter;
    if (hiddenInput) hiddenInput.value = meter;

    const totalQty = qty * meter;

    // if(document.body.classList.contains('template-cart')){
    //     const themeCart = document.querySelector('theme-cart');
    //     if (themeCart && typeof themeCart.updateQuantity === 'function') {
    //     themeCart.updateQuantity(line, totalQty, {
    //         'Qty': qty,
    //         'Meter': meter
    //     });
    //     } else {
    //     console.warn('theme-cart element not found — cannot update quantity/properties.');
    //     }
    // }else{
    //     const themeCartdrawer = document.querySelector('cart-drawer');
    //     if (themeCartdrawer && typeof themeCartdrawer.updateQuantity === 'function') {
    //     themeCartdrawer.updateQuantity(line, totalQty, {
    //         'Qty': qty,
    //         'Meter': meter
    //     });
    //     } else {
    //     console.warn('theme-cart element not found — cannot update quantity/properties.');
    //     }

    // }



        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const lineItem = cart.items[line - 1];

            if (!lineItem) {
            console.warn('Line item not found:', line);
            return;
            }

            // Keep all existing properties
            const properties = {
            ...(lineItem.properties || {}),
            'Qty': qty,
            'Meter': meter
            };

            if (document.body.classList.contains('template-cart')) {
            const themeCart = document.querySelector('theme-cart');

            if (themeCart && typeof themeCart.updateQuantity === 'function') {
                themeCart.updateQuantity(line, totalQty, properties);
            } else {
                console.warn('theme-cart element not found — cannot update quantity/properties.');
            }

            } else {
            const themeCartdrawer = document.querySelector('cart-drawer');

            if (themeCartdrawer && typeof themeCartdrawer.updateQuantity === 'function') {
                themeCartdrawer.updateQuantity(line, totalQty, properties);
            } else {
                console.warn('cart-drawer element not found — cannot update quantity/properties.');
            }
            }
        });

  }

  // Capture phase, so this runs BEFORE the event bubbles into #cart-form
  // and triggers the theme's own onFormChange for these inputs.
  document.addEventListener('change', function (e) {
    console.log('hii change');
    if (e.target.matches('.cartorderQty, .cartmeterQty')) {
        console.log('hii change 1');
      e.stopPropagation();
      const wrapper = e.target.closest('.custom-meter-order');
      console.log('wrapper',wrapper);
      if (wrapper) updateRow(wrapper);
    }
  }, true);

})();